class StepsAlgorithm {
    readonly steps: number[];
    private step: number | undefined;

    constructor(steps: number[]) {
        this.steps = steps;
    }

    stepUp(): number {
        this.step = this.step === undefined ? 0 : this.step + 1;

        if (this.step >= this.steps.length) {
            this.step = this.steps.length - 1;
        }
        return this.steps[this.step];
    }

    stepDown(): number {
        this.step = this.step === undefined ? this.steps.length - 1 : this.step - 1;

        if (this.step < 0) {
            this.step = 0;
        }
        return this.steps[this.step];
    }
}

export class Cos2 extends StepsAlgorithm {
    static stepsCos2Coarse: number[] = [0, 0.095, 0.345, 0.500, 0.655, 0.905, 1]
    static stepsCos2: number[] = [0, 0.024, 0.095, 0.206, 0.345, 0.500, 0.655, 0.794, 0.905, 0.976, 1]
    static stepsCos2Fine: number[] = [0, 0.004, 0.016, 0.035, 0.062, 0.095, 0.136, 0.181, 0.232, 0.287, 0.345, 0.406, 0.469, 0.531, 0.594, 0.655, 0.713, 0.768, 0.819, 0.864, 0.905, 0.938, 0.965, 0.984, 0.996, 1];

    constructor() {
        super(Cos2.stepsCos2Fine)
    }
}

export class Rect extends StepsAlgorithm {
    constructor() {
        super([0, 1])
    }
}

export class Linear extends StepsAlgorithm {
    static stepsLinearCoarse: number[] = [0, 0.2, 0.4, 0.6, 0.8, 1]
    static stepsLinear: number[] = [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
    static stepsLinearFine: number[] = [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1]

    constructor() {
        super(Linear.stepsLinearFine)
    }
}